import { render, staticRenderFns } from "./CyberboardR6.vue?vue&type=template&id=0a055765"
import script from "./CyberboardR6.vue?vue&type=script&lang=ts"
export * from "./CyberboardR6.vue?vue&type=script&lang=ts"
import style0 from "../assets/styles/pages/CyberboardR6.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports